// BannerWhatsApp.jsx
import React from 'react';

const BannerWhatsApp = () => {
  const whatsappLink = "https://chat.whatsapp.com/KLkhxBs2YgSGdgN56FjCQH";

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full max-w-5xl mx-auto my-8 px-4 sm:px-6"
    >
      <div 
        className="
          relative overflow-hidden 
          bg-gradient-to-r from-emerald-900 via-emerald-800 to-emerald-700 
          rounded-2xl sm:rounded-3xl 
          shadow-2xl 
          transition-all duration-500 
          hover:shadow-emerald-900/40 
          group
        "
      >
        {/* Subtle background pattern */}
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(255,255,255,0.12)_0%,transparent_50%)]" />
        </div>

        <div className="relative px-6 py-10 sm:px-10 sm:py-12 md:px-12 md:py-14 flex flex-col sm:flex-row items-center justify-between gap-8 md:gap-12">
          
          {/* Left side - Text & Icon */}
          <div className="flex items-center gap-5 sm:gap-7">
            {/* WhatsApp Icon with pulse animation */}
            <div className="relative">
              <div className="
                w-20 h-20 sm:w-24 sm:h-24 
                bg-[#25D366] 
                rounded-2xl 
                flex items-center justify-center 
                shadow-lg 
                transform 
                group-hover:scale-110 
                transition-transform duration-400
              ">
                <span className="text-5xl sm:text-6xl">💬</span>
              </div>
              
              {/* Small pulse ring */}
              <div className="
                absolute -inset-2 
                rounded-3xl 
                bg-[#25D366]/30 
                animate-ping 
                animation-duration-2000
              "></div>
            </div>

            <div>
              <h2 className="
                text-2xl sm:text-3xl md:text-4xl 
                font-bold 
                text-white 
                tracking-tight
              ">
                Join Our WhatsApp Community
              </h2>
              
              <p className="
                mt-2 sm:mt-3 
                text-base sm:text-lg 
                text-emerald-100/90 
                font-light
              ">
                Get instant job alerts • Fresh opportunities • Free
              </p>
            </div>
          </div>

          {/* Right side - CTA Button */}
          <div className="flex flex-col items-center sm:items-end gap-3 sm:gap-4">
            <button 
              className="
                group relative 
                flex items-center gap-3 
                bg-[#25D366] 
                hover:bg-[#20b958] 
                text-white 
                font-semibold 
                text-base sm:text-lg 
                px-8 sm:px-10 py-4 sm:py-5 
                rounded-xl sm:rounded-2xl 
                shadow-lg 
                shadow-emerald-900/30 
                transition-all duration-300 
                hover:shadow-xl 
                hover:shadow-emerald-700/40 
                hover:scale-105 
                active:scale-95
              "
            >
              <span>Join Now</span>
              
              <svg 
                className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform duration-300" 
                fill="currentColor" 
                viewBox="0 0 20 20"
              >
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>

            <p className="
              text-xs sm:text-sm 
              text-emerald-200/80 
              font-light
            ">
              Only verified job opportunities • No spam
            </p>
          </div>
        </div>
      </div>
    </a>
  );
};

export default BannerWhatsApp;